// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-102bc119]{border-collapse:collapse}table[data-v-102bc119],td[data-v-102bc119],th[data-v-102bc119]{border:.5px solid #000}thead[data-v-102bc119]{display:table-row-group}tr td[data-v-102bc119]{page-break-inside:avoid}@media print{div.footer[data-v-102bc119]{bottom:0;margin-top:10px;position:fixed}div.footer p[data-v-102bc119]{text-align:center}}.no-border[data-v-102bc119]{border:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
